import { NAME } from './constants';

export const getFlight = state => state[NAME];
export const isLoaded = globalState => (globalState[NAME] && globalState[NAME].loaded);



// WEBPACK FOOTER //
// ./modules/SingleFlight/redux/selectors.js